export default "__VITE_ASSET__pzpF1U8A__"